import { License } from "../../picreplacement/check";
import { LicenseState } from "./data-collection.types";
export function isValidLicenseState(candidate) {
    return (typeof candidate === "string" && Object.values(LicenseState).includes(candidate));
}
export const doesLicenseStateMatch = async function (behavior) {
    if (!behavior.licenseStateList) {
        return true;
    }
    const licenseStates = behavior.licenseStateList.split(",");
    await License.ready();
    return licenseStates.some((state) => (state === LicenseState.active && License.isActiveLicense()) ||
        (state === LicenseState.inactive && !License.isActiveLicense()));
};
export const defaultLicenseState = LicenseState.inactive;
